import { appBranding } from './Branding/Branding';
import React from 'react';
import StyledHeader, { RightAlign, StyledLink } from './Header.styles';
import { HelpMenu } from './HelpMenu';
import { Logo } from './Logo/Logo';
import TenantPicker from './OrgSwitcher';
import StylovyzeNotification from './StylovyzeNotification';
import UserProfile from './UserProfile';
import { useConsumeWeaveTheme } from '../../theme/WeaveContext';
export const Header = ({ branding, isTenantAware = true, helpUrl, aboutBox, hasLoginPicker = false, inEmulation = false, notificationConfig, withHelpbot, }) => {
    const notificationEnabled = !!notificationConfig;
    const { resolvedRoles, isWeaveTheme } = useConsumeWeaveTheme();
    const backgroundColor = isWeaveTheme && resolvedRoles['menu.backgroundColor'];
    const textColor = isWeaveTheme && resolvedRoles['colorScheme.text.default'];
    return (React.createElement(StyledHeader, { backgroundColor: backgroundColor, textColor: textColor },
        React.createElement(StyledLink, { to: "/" },
            React.createElement(Logo, { ...appBranding[branding] })),
        React.createElement(RightAlign, { "data-cy": "header-user-context" },
            isTenantAware && (React.createElement(TenantPicker, { "data-testing-id": "org-switcher-button" })),
            notificationEnabled && (React.createElement(StylovyzeNotification, { config: {
                    applicationId: notificationConfig.applicationId,
                    userId: notificationConfig.userId,
                    tenantId: notificationConfig.tenantId,
                    product: notificationConfig.product,
                } })),
            React.createElement(HelpMenu, { helpUrl: helpUrl, withHelpBot: withHelpbot }),
            React.createElement(UserProfile, { aboutBox: aboutBox, "data-testing-id": "user-profile-button", hasLoginPicker: hasLoginPicker, inEmulation: inEmulation }))));
};
export default Header;
